import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, timeout } from 'rxjs/operators';
import { CardXResponseSaveRequest } from '../shared/models/CardXResponseSaveRequest';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  })
};

@Injectable({
  providedIn: 'root'
})
export class CardRegistrationService {

  protected validateTokenUrl = '/soa-infra/resources/external/tokenizer/rest/validate';
  protected cardXResponseUrl = '/soa-infra/resources/external/cardregistration/rest/register';

  constructor(private _http: HttpClient) { }

  saveCardXResponse(request: CardXResponseSaveRequest): Observable<any> {
    const endpoint = `${this.cardXResponseUrl}`;
    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Authorization' : environment.soa_authorization
      })
    };
    return this._http.post<any>(endpoint, request, httpOptions1)
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  vaidateToken(token:any, type:any): Observable<any> {
    const contentText = '?content=';
    const typeText = '&type='
    const endpoint = `${this.validateTokenUrl}${contentText}${token}${typeText}${type}`;
    return this._http.get<any>(endpoint, httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }
  // Error handler
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Client-side Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Server-side Error: ${error.status}\nMessage: ${error.message}`;    
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

}
